"use client";

import { useForm } from "react-hook-form";
import { memberSchema, MailchimpFormValues } from "./MemberFormTypes";
import { zodResolver } from "@hookform/resolvers/zod";
import { useActionState } from "react";
import mailchimpSubscribeAction from "./MemberSubscribeAction";

export default function MemberSubscribeForm() {
  const { register } = useForm<MailchimpFormValues>({
    mode: "onChange",
    resolver: zodResolver(memberSchema),
    defaultValues: {
      firstName: "",
      lastName: "",
      email: "",
    },
  });

  const [state, action, isPending] = useActionState(
    mailchimpSubscribeAction,
    null
  );

  return (
    <form action={action}>
      {state?.status === "success" && (
        <div>
          <p
            className={`
              text-fluid-sm
              bg-young-grain-darker
              ml-auto
              mr-auto
              w-[30%]
              rounded-[0.5rem]
              pt-4
              pb-4
              mb-4
              mt-4
            `}
          >
            {state.message}
          </p>
        </div>
      )}
      {state?.status === "error" && (
        <div>
          <p
            className={`
              text-fluid-sm
              bg-burgundy
              m-auto
              w-[30%]
              rounded-[0.5rem]
              pt-4
              pb-4
              mt-4
              mb-4
            `}
          >
            {state.message}
          </p>
        </div>
      )}
      <div>
        <input
          {...register("firstName")}
          placeholder="First name"
          className={`
          bg-sand
          mb-4
          border-black
          rounded-[0.5rem]
          text-fluid-md
          text-earth
          pl-4
      `}
        />
        {state?.error?.fieldErrors.firstName?.map((error) => {
          return <p key={error}>{error}</p>;
        })}
      </div>
      <div>
        <input
          {...register("lastName")}
          placeholder="Last name"
          className={`
          bg-sand
          mb-4
          border-black
          rounded-[0.5rem]
          text-fluid-md
          text-earth
          pl-4
      `}
        />
        {state?.error?.fieldErrors.lastName?.map((error) => {
          return <p key={error}>{error}</p>;
        })}
      </div>
      <div>
        <input
          {...register("email")}
          placeholder="example@email.com"
          className={`
          bg-sand
          mb-4
          border-black
          rounded-[0.5rem]
          text-fluid-md
          text-earth
          pl-4
      `}
        />
        {state?.error?.fieldErrors.email?.map((error) => {
          return (
            <p
              key={error}
              className={`
                text-fluid-sm
                bg-burgundy
                m-auto
                w-[30%]
                rounded-[0.5rem]
                p-2
              `}
            >
              {error}
            </p>
          );
        })}
      </div>
      <div>
        <button
          type="submit"
          disabled={isPending}
          className={`
            rg-button
            text-fluid-sm
            mt-4
            p-3
            ml-2
            rounded-[0.5rem]
            cursor-pointer
            disabled:opacity-50
            disabled:cursor-not-allowed
            `}
        >
          Subscribe
        </button>
      </div>
    </form>
  );
}